import { Integration_Names_Enum } from '@main/graphql/types.generated';

export const CONFIGURABLE_IN_APP_INTEGRATIONS: Integration_Names_Enum[] = [
  Integration_Names_Enum.Sharepoint,
  Integration_Names_Enum.Zendesk,
];

export function isConfigurableInAppIntegraion(name: Integration_Names_Enum) {
  return CONFIGURABLE_IN_APP_INTEGRATIONS.includes(name);
}
